var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3233 2.59467C10.0305 2.30185 9.55574 2.30177 9.26282 2.59449L3.42688 8.42653C3.13389 8.71932 3.13373 9.1942 3.42652 9.48719C3.71932 9.78018 4.19419 9.78034 4.48718 9.48754L9.04297 4.93481V16.875C9.04297 17.2892 9.37876 17.625 9.79297 17.625C10.2072 17.625 10.543 17.2892 10.543 16.875V4.93566L15.0947 9.48737C15.3876 9.78026 15.8624 9.78026 16.1553 9.48737C16.4482 9.19447 16.4482 8.7196 16.1553 8.42671L10.3233 2.59467Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrow-top.4c0d43fdabd176b09124f17d356aac4b.svg";
export { ForwardRef as ReactComponent };